/** Coerce API numeric fields (incl. SQL BIGINT strings) to a finite number. */
export function metricNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function sumUserRequestTotals(user) {
  return (
    metricNumber(user?.totalComposerRequests)
    + metricNumber(user?.totalChatRequests)
    + metricNumber(user?.totalAgentRequests)
    + metricNumber(user?.totalCmdKUsages)
    + metricNumber(user?.totalBugbotUsages)
  );
}

export function sumTeamRequestTotals(team) {
  const direct = metricNumber(team?.totalRequests);
  if (direct > 0) return direct;
  return (
    metricNumber(team?.totalComposerRequests)
    + metricNumber(team?.totalChatRequests)
    + metricNumber(team?.totalAgentRequests)
    + metricNumber(team?.totalCmdKUsages)
    + metricNumber(team?.totalBugbotUsages)
  );
}

export function formatIntegerMetric(value) {
  return metricNumber(value).toLocaleString('en-US');
}

export function formatDecimalMetric(value, digits = 1) {
  return metricNumber(value).toFixed(digits);
}
